import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-field-value-detail',
  templateUrl: './field-value-detail.component.html',
  styleUrls: ['./field-value-detail.component.css']
})
export class FieldValueDetailComponent implements OnInit {

  @Input() modalTitle: string;
  objInitialState;
  fieldValue;

  constructor(public bsModalRef: BsModalRef) {

  }

  ngOnInit() {
    if (this.objInitialState){
      this.fieldValue = this.objInitialState;
    }
  }

  onClose() {
    this.bsModalRef.hide();
  }
}
